import { render, staticRenderFns } from "./addNewModel.vue?vue&type=template&id=a4c8c4ae"
import script from "./addNewModel.vue?vue&type=script&lang=js"
export * from "./addNewModel.vue?vue&type=script&lang=js"
import style0 from "./addNewModel.vue?vue&type=style&index=0&id=a4c8c4ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports